<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <!--
          <el-form-item label="" class="pr-10">
            <el-select
              v-model="queryForm.branchId"
              clearable
              placeholder="分店"
            >
              <el-option
                v-for="item in branchList"
                :key="item.branchId"
                :label="item.title"
                :value="item.branchId"
              ></el-option>
            </el-select>
          </el-form-item>
        -->
          <el-form-item label="" class="pr-10">
            <el-input v-model="queryForm.carRecordNo" placeholder="申请编号" clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="" class="pr-10">
            <el-select v-model="queryForm.org" placeholder="用车单位" clearable>
              <el-option
                v-for="item in orgs"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" class="pr-10">
            <el-select v-model="queryForm.mode" placeholder="用车类型" clearable>
              <el-option
                v-for="item in modes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" class="pr-10">
            <el-select v-model="queryForm.carId" placeholder="车型" clearable>
              <el-option
                v-for="item in cars"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" class="pr-10">
            <el-select v-model="queryForm.createdPeopleId" placeholder="申请人" clearable>
              <el-option
                v-for="item in staffs"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" class="pr-10">
            <el-select v-model="queryForm.step" placeholder="状态" clearable>
              <el-option
                v-for="item in steps"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" class="pr-10">
            <el-date-picker
              v-model="queryForm.startDate"
              type="date"
              placeholder="开始提交日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryForm.endDate"
              type="date"
              placeholder="结束提交日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column
        align="left"
        label="申请编号"
        prop="basic.carRecordNo"
        show-overflow-tooltip
      />
      <!--
      <el-table-column
        align="left"
        label="门店"
        prop="branch.title"
        show-overflow-tooltip
      />
    -->
      <el-table-column
        align="left"
        label="用车单位"
        prop="basic.org"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="用车类型"
        prop="basic.mode"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="车型"
        prop="basic.mode"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ row.car?row.car.mode:'车辆已删除' }} {{ row.car&&'（'+row.car.title+'）' }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="乘务员额"
        prop="basic.peopleCount"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="出车时间"
        prop="basic.outTime"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row }">
          {{ moment(row.basic.outTime).format('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="出发地点"
        prop="basic.outAddress"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="归队时间"
        prop="basic.returnTime"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row }">
          {{ moment(row.basic.returnTime).format('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="申请人"
        prop="createdPeople.name"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="状态"
        prop="basic.step"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ formatStep(row.step) }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="提交时间"
        prop="createdTime"
        show-overflow-tooltip
        width="180"
      >
        <template #default="{ row }">
          {{ moment(row.createdTime).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="备注"
        prop="basic.text"
        show-overflow-tooltip
        width="180"
      >
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
   
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { findCarRecordList, findCarList ,removeCarRecord} from '@/api/oa'
import { findList, } from '@/api/staff'
import { getAllBranchs } from '@/api/branch'
import { reactive, ref, getCurrentInstance } from 'vue'
import commomFunction from '../common'

export default {
  name: 'OaCarIndex',
  setup() {
    const { proxy } = getCurrentInstance()
    const list = reactive([])
    const branchList = reactive([])
    const stepList = [
      {
        label: '已生效',
        value: 1,
      },
      {
        label: '待生效',
        value: 2,
      },
    ]
    const orgs = [{
      label: '大队部',
      value: '大队部',
    }, {
      label: '化工园区站',
      value: '化工园区站',
    }]
    const modes = [{
      label: '行政车辆',
      value: '行政车辆',
    }, {
      label: '执勤车辆',
      value: '执勤车辆',
    }]
    const steps = [{
      label: '待审核',
      value: 1,
    }, {
      label: '已通过',
      value: 2,
    }, {
      label: '已拒绝',
      value: 3,
    }, {
      label: '已归队',
      value: 4,
    }]
    const cars = []
    const staffs = []
    const listLoading = ref(true)
    const layout = 'total, sizes, prev, pager, next, jumper'
    const total = ref(0)
    const { staffList } = commomFunction()
    const queryForm = reactive({
      page: 1,
      size: 10,
      createPeopleId: '',
      followPeopleId: '',
      filterMode: 3,
      branchId: '',
      step: '',
      keyword: '',
    })
    const edit = ref(null)
    const fetchData = async () => {
      listLoading.value = true
      const { list: list1, total: total1 } = await findCarRecordList(
        queryForm
      )
      list.length = 0
      list.push(...list1)
      total.value = total1
      listLoading.value = false
    }
    const queryData = () => {
      queryForm.page = 1
      fetchData()
    }
    const formatStep = (step) => {
      const find = steps.find(e => e.value == step)
      return find && find.label || '未知'
    }
    //添加和编辑
    const handleEdit = (edit, row) => {
      edit.showEdit(row)
    }
    const getAllBranchList = async () => {
      const res = await getAllBranchs({})
      if (!res) return
      branchList.length = 0
      branchList.push(...res)
    }
    const getAllCars = async () => {
      const res = await findCarList({
        page: 1,
        size: 100,
      })
      if (!res) return
      cars.push(...res.list.map(e => ({
        label: `${e.basic.mode}（${e.title}）`,
        value: e.carId,
      })))
    }
    const getAllStaffs = async () => {
      const res = await findList({
        page: 1,
        size: 100,
      })
      if (!res) return
      staffs.push(...res.list.map(e => ({
        label: e.basic.name,
        value: e.peopleId,
      })))
    }
    const handleDelete = (row) => { 
      proxy.$baseConfirm(
        `你确定要删除车辆申请记录吗`,
        null,
        async () => {
          await removeCarRecord({
            carRecordId: row.carRecordId,
          })
          proxy.$baseMessage(
            `删除车辆成功`,
            'success',
            false,
            'vab-hey-message-success'
          )
          queryData()
        }
      )
    }
    //分页
    const handleSizeChange = (val) => {
      queryForm.size = val
      fetchData()
    }
    const handleCurrentChange = (val) => {
      queryForm.page = val
      fetchData()
    }
    getAllBranchList()
    getAllCars()
    getAllStaffs()
    //拉取数据
    queryData()
    return {
      list,
      orgs,
      modes,
      cars,
      steps,
      staffs,
      listLoading,
      layout,
      total,
      formatStep,
      queryForm,
      moment,
      edit,
      stepList,
      staffList,
      branchList,
      fetchData,
      queryData,
      handleEdit,
      handleDelete,
      handleSizeChange,
      handleCurrentChange,
    }
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
